import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const ProfileIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Halo menthe */}
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      {/* Tête */}
      <circle cx="12" cy="10" r="3" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" fill="hsl(var(--background))" />
      {/* Buste */}
      <path
        d="M6 19c.7-2.8 3.1-4.5 6-4.5s5.3 1.7 6 4.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" fill="hsl(var(--background))"
      />
    </svg>
  ),
);
ProfileIcon.displayName = "ProfileIcon";
